import { lazy } from 'react';
//import TrialBalance from "../pages/TrialBalance/TrialBalance";

const TrialBalance = lazy(() => import('../pages/TrialBalance/TrialBalance'));

const trialBalanceRoute = {
  public: [],
  auth: [
    {
      name: 'trial_balance_report',
      path: '/finance-and-accounting/trial-balance',
      component: TrialBalance,
    },
  ],
};

export default trialBalanceRoute;
